import React from 'react';

const Carousel = () => {
  return (
    <div id="header-carousel" className="carousel slide carousel-fade" data-bs-ride="carousel" >
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img className="w-100" src="../assetsTemplates/template1/img/carousel-1.jpg" alt="Image" style={{ objectFit: 'cover', height: '70vh' }} />
          <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
            <div className="p-3" style={{ maxWidth: '900px' }}>
              <h5 className="text-white text-uppercase mb-3 animated slideInDown" style={{ textShadow: '1px 1px 3px rgba(0, 0, 0, 0.7)' }}>Welcome to the</h5>
              <h1 className="display-1 text-white mb-md-4 animated zoomIn" style={{ textShadow: '1px 1px 5px rgba(0, 0, 0, 0.9)' }}>National Center of Informatics</h1>
              <a href="/SignUp" className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft">Join Us</a>
              <a href="/SignIn" className="btn btn-outline-light py-md-3 px-md-5 animated slideInRight">Get Started</a>
            </div>
          </div>
        </div>
        <div className="carousel-item">
          <img className="w-100" src="../assetsTemplates/template1/img/carousel-2.jpg" alt="Image" style={{ objectFit: 'cover', height: '70vh' }} />
          <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
            <div className="p-3" style={{ maxWidth: '900px' }}>
              <h5 className="text-white text-uppercase mb-3 animated slideInDown" style={{ textShadow: '1px 1px 3px rgba(0, 0, 0, 0.7)' }}>Welcome to the</h5>
              <h1 className="display-1 text-white mb-md-4 animated zoomIn" style={{ textShadow: '1px 1px 5px rgba(0, 0, 0, 0.9)' }}>National Center of Informatics</h1>
              <a href="/SignUp" className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft">Join Us</a>
              <a href="/SignIn" className="btn btn-outline-light py-md-3 px-md-5 animated slideInRight">Get Started</a>
            </div>
          </div>
        </div>
      </div>
      <button className="carousel-control-prev" type="button" data-bs-target="#header-carousel" data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#header-carousel" data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default Carousel;
